import React from 'react';
import { IAuditoriaProvisaoIcmsResultado } from '../interfaces/IAuditoriaProvisaoIcms';
import { TributoAuditoria } from '../interfaces/IAuditoria';
import { formatCurrency } from '../utils/formatters';

interface Props {
  resultado?: IAuditoriaProvisaoIcmsResultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}


const AuditoriaResumoProvisaoIcms: React.FC<Props> = ({ resultado, onSelecionar }) => {
  if (!resultado) {
    return null;
  }

  const totalOcorrencias = resultado.anomaliasDetectadas?.length || 0;

  return (
    <div className='auditoria-card mt-5'>
      <h3>Resumo de Provisão Mensal de ICMS</h3>
      <p className='text-muted'>
        Meses com carga tributária de ICMS abaixo de 80% da média móvel dos 3 meses anteriores — indício de
        subfaturamento ou erro de lançamento (Lei Complementar nº 87/1996). Clique para ver a análise detalhada.
      </p>

      <div className='table-responsive mt-4'>
        <table className='auditoria-table auditoria-table-tributos'>
          <thead>
            <tr>
              <th>Auditoria</th>
              <th className='text-end'>Multa ECD Potencial</th>
              <th className='text-center'>Erros</th>
              <th className='text-center'>Avisos</th>
              <th className='text-center'>Alertas</th>
            </tr>
          </thead>

          <tbody>
            <tr className='auditoria-row-tributo' onClick={() => onSelecionar('AUDITORIA_PROVISAO_ICMS')}>
              <td className='auditoria-col-tributo'>
                <div className='d-flex align-items-center gap-2'>
                  <strong>Provisão Mensal de ICMS sobre Vendas e Revendas</strong>
                  <span className={`auditoria-status status-${resultado.status}`}>
                    {resultado.status}
                  </span>
                </div>
                <div className='auditoria-legislacao-inline'>
                  <div>{totalOcorrencias} competência{totalOcorrencias === 1 ? '' : 's'} com carga tributária anômala no período</div>
                  <div className='text-muted'>{resultado.mensagemDirecionamento}</div>
                </div>
              </td>
              <td className='text-end auditoria-col-highlight'>
                {formatCurrency(resultado.impactoFiscalTotal)}
                <div className='auditoria-kpi-help'>Multa ECD potencial — 5% sobre o faturamento do mês com anomalia, limitada a 1% da receita bruta do período (Art. 12, II, Lei 8.218/91).</div>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-erro'>{resultado.totalErros}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-aviso'>{resultado.totalAvisos}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-alerta'>{resultado.totalAlertas}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditoriaResumoProvisaoIcms;
